// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1usP-","head":"ProcedureTableInfo_head__3zLSA"};